// extracted by mini-css-extract-plugin
module.exports = {"tile":"DonationPromptTile_tile__k0r5F","description":"DonationPromptTile_description__qLnTa","amount":"DonationPromptTile_amount__Bq_hc","type":"DonationPromptTile_type__5wb88"};